module.exports = __webpack_public_path__ + "static/din-popup-bg-ac4d18ee0786935ca269bf4b559a4389.png";